export const CountryBankAccountNumberLength = {
    'United Kingdom': 8,
    Ireland: 22,
    Australia: 9,
    'New Zealand': 16,
    Canada: 12,
    'United States': 17,
    Mexico: 18
};
